import account from "./account";
import accountMgt from "./accountMgt";
import backend from "./backend";
import admin from "./admin";
import superAdmin from "./superAdmin";
export default { account, backend, accountMgt, admin, superAdmin };
